import React, { useState } from "react";
import "../css/appStyling.css";
import axios from "axios";
import BackToHome from "./BackToHome";

function Quotes() {
  const [quote, setQuote] = useState("");

  const fetchQuotes = async () => {
    try {
      const responseData = await axios.get(
        "https://gist.githubusercontent.com/g-rohit/7eea79e9343bb70ce25485c202351ec5/raw/6af5c1583e057d7e5420a44b4dcaf01fb7ac93f8/quotes.json"
      );

      const quotesCollection = responseData.data.quotes;

      const randomIndex = Math.floor(Math.random() * quotesCollection.length);

      const randomQuote = quotesCollection[randomIndex];

      console.log(randomIndex, randomQuote);

      setQuote(randomQuote);

    } catch (error) {
      console.log("error is: ", error);
    }
  };

  return (
    <>
      <div className="quotes-container" id="quotes-generator">
        <button onClick={fetchQuotes} className="btn-textUtil">
          Read an Inspiring Quote
        </button>
        <div className="w-75">
          <p>{quote.quote} </p>
          {quote.author && (
            <span className="author-name"> By - {quote.author}</span>
          )}
        </div>
      </div>
      <BackToHome/>
    </>
  );
}

export default Quotes;


 